<template>
  <div class="edit-sp-profile-control-buttons">
    <div class="preview" slot="buttonContent">
      <v-btn class='preview_btn' slot="buttonContent" @click="onOpenPreviewClicked" text>
       {{ $t('edit.sp.employee.profile.preview.button') }}
      </v-btn>
    </div>
    <div class="active_not_active" slot="buttonContent">
      <v-btn small class='active_not_active_btn' slot="buttonContent" @click="onResetActiveClicked" text>
          <v-icon class="material-icons-round">swap_horiz</v-icon>
      </v-btn>
    </div>
    <div class="delete" slot="buttonContent" v-if='!isCurrentConnectedUser'>
      <v-btn small class='delete_btn' slot="buttonContent" @click="deleteEmployee" text>
        <img :src="deleteIcon" alt="" />
      </v-btn>
    </div>
    <YesNoPopup
      :message='popUpMessage'
      title="edit.service.provider.employee.profile.delete.pop.up.title"
      no-caption="edit.service.provider.employee.profile.delete.pop.up.no"
      yes-caption="edit.service.provider.employee.profile.delete.pop.up.yes"
      :visible-popup='visiblePopUp'
      @clicked='onClickYesNoButton'
    />
    <span class="escape-link" @click="onEscapeClicked()"> X {{ $t('edit.sp.employee.profile.esc') }} </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import deleteIcon from '@/assets/delete.svg';
import YesNoPopup from '@/components/popup/YesNoPopup.vue';

export default {
  name: 'EditSPEmployeeProfileControlButtons',
  components: {
    YesNoPopup,
  },
  data() {
    return {
      visiblePopUp: false,
    };
  },
  methods: {
    async onClickYesNoButton(value) {
      this.visiblePopUp = false;
      if (value) {
        this.$emit('onDeleteClicked');
      }
    },
    onEscapeClicked() {
      this.$emit('onEscapeClicked');
    },
    onResetActiveClicked() {
      this.$emit('onResetActiveClicked');
    },
    deleteEmployee() {
      this.visiblePopUp = true;
    },
    onOpenPreviewClicked() {
      this.$emit('onOpenPreviewClicked');
    },
  },
  computed: {
    ...mapGetters(['currentSPEmployee', 'chosenSPEmployeeId', 'profile']),
    isCurrentConnectedUser() {
      return this.chosenSPEmployeeId === this.profile?.id;
    },
    popUpMessage() {
      let text = ` ${this.$t('edit.service.provider.employee.profile.delete.pop.up')} `;
      text += this.currentSPEmployee.email;
      text += ` ${this.$t('edit.service.provider.employee.profile.delete.pop.up.continue')} \r\n`;
      text += this.$t('edit.service.provider.employee.profile.delete.pop.up.irreversible');
      return text;
    },
    deleteIcon() {
      return deleteIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.v-btn:not(.v-btn--round).v-size--small {
  min-width: rem(28);
  width: rem(28) !important;
}

.edit-sp-profile-control-buttons {
  display: flex;
  align-items: center;

  .escape-link {
    float: right;
    cursor: pointer;
    margin-left: rem(20);
    text-align: right;
    font-size: rem(12);
    text-transform: uppercase;
    text-decoration: none;
    color: var(--text-secondary);
    font-family: $font-family-medium;
    font-weight: 500;
    letter-spacing: rem(1.1);
  }

  .preview_btn {
    margin-right: rem(12);
    text-align: right;
    box-sizing: border-box;
    height: rem(32);
    width: rem(86);
    border: rem(1) solid var(--brand-primary);
    color: var(--brand-primary);
    border-radius: $radius-sm;
    background-color: var(--bg-primary);
    box-shadow: 0 rem(1) rem(1) 0 rgba(0, 0, 0, 0.14), 0 rem(2) rem(1) rem(-1) rgba(0, 0, 0, 0.12),
      0 rem(1) rem(3) 0 rgba(0, 0, 0, 0.2) !important;
  }

  .delete {
    margin-right: rem(12);
    align-items: center;
    background-color: #FBE9EE;
    border-radius: $radius-sm;
    cursor: pointer;
    display: flex;
    height: rem(28);
    justify-content: center;
    width: rem(28);
  }

  .active_not_active {
    &_btn {
      color: var(--brand-primary) !important;
    }

    margin-right: rem(12);
    align-items: center;
    background-color: #EDF5FD;
    border-radius: $radius-sm;
    cursor: pointer;
    display: flex;
    height: rem(28);
    justify-content: center;
    width: rem(28);
  }

  .save-button {
    float: right;
    margin-top: rem(12);
    display: inline-block;
    cursor: pointer;
    height: rem(32);
    width: rem(66);
    border-radius: $radius-sm;
    background-color: #4d9feb;
    box-shadow: 0 rem(1) rem(1) 0 rgba(0, 0, 0, 0.14), 0 rem(2) rem(1) rem(-1) rgba(0, 0, 0, 0.12), 0 rem(1) rem(3) 0 rgba(0, 0, 0, 0.2);
    color: #ffffff;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);
    text-align: center;
    text-transform: uppercase;
    padding-top: rem(8);

    &.disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
}
</style>
